__turbopack_context__.v({
  "modal": "_2BNYDa_modal",
  "modalBody": "_2BNYDa_modalBody",
  "modalFooter": "_2BNYDa_modalFooter",
});
